"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
var _marqueeVideo = _interopRequireDefault(require("../../../common/marquee-video.js"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
/* eslint-disable complexity */

const ImageContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainer",
  class: "pl-iv3ypuh"
});
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-vr2xccq"
});

/**
 * MegaMarquee Media Component.
 *
 * @param {Object} props React props
 * @param {Object} props.image Image
 * @param {Object} props.size Size object containing breakpoints
 * @param {Object} props.introUrls Object containing video URLs
 * @param {React.ReactElement} props.videos Video component
 * @returns {React.ReactElement} Media Component
 * @public
 */

function Media({
  image,
  introUrls,
  videos
}) {
  const hasImage = image?.portrait?.url || image?.landscape?.url;
  const hasVideo = introUrls?.introUrl || introUrls?.introUrlWebm || videos && /*#__PURE__*/_react.default.isValidElement(videos);
  if (!hasVideo && !hasImage) return null;
  let fallbackImage = {};
  if (image?.portrait?.url) {
    fallbackImage = image.portrait;
  } else if (image?.landscape?.url) {
    fallbackImage = image.landscape;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "media-container",
    "data-cy": "media-container"
  }, hasImage && /*#__PURE__*/_react.default.createElement(ImageContainer, {
    "data-cy": "image-container",
    tabIndex: "0",
    "data-partial": "boxRadiusLarge"
  }, /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    defaultSrc: fallbackImage.url,
    defaultAltText: fallbackImage.altText,
    width: fallbackImage.width,
    height: fallbackImage.height,
    loading: "eager",
    dataCy: "media-image-portrait"
  }, image?.landscape?.url && /*#__PURE__*/_react.default.createElement("source", {
    srcSet: image.landscape.url,
    "data-cy": "media-image-landscape",
    media: `(min-width: ${_patternLibraryUtils.size.mobileLg}px)`,
    width: image.landscape.width,
    height: image.landscape.height
  }))), hasVideo && /*#__PURE__*/_react.default.createElement(VideoContainer, {
    "data-cy": "video-container",
    "data-partial": "boxRadiusLarge"
  }, /*#__PURE__*/_react.default.createElement(_marqueeVideo.default, {
    introUrl: introUrls?.introUrl,
    introUrlWebm: introUrls?.introUrlWebm,
    introUrlLaptop: introUrls?.introUrlLaptop,
    introUrlLaptopWebm: introUrls?.introUrlLaptopWebm,
    thumbnailDesktop: image?.landscape?.url,
    thumbnailMobile: image?.portrait?.url,
    videos: videos
  })));
}
Media.propTypes = {
  image: _propTypes.default.shape({
    portrait: _propTypes.default.shape(_patternLibraryUtils.bynderImageProps),
    landscape: _propTypes.default.shape(_patternLibraryUtils.bynderImageProps)
  }),
  fallbackImage: _propTypes.default.shape(_patternLibraryUtils.bynderImageProps),
  hasVideo: _propTypes.default.bool,
  introUrls: _propTypes.default.shape({
    introUrl: _propTypes.default.string,
    introUrlWebm: _propTypes.default.string,
    introUrlLaptop: _propTypes.default.string,
    introUrlLaptopWebm: _propTypes.default.string
  }),
  videos: _propTypes.default.element
};
var _default = exports.default = Media;